const fineCalculatorStyles = {
  paper: {
    width: 700,
    margin: "0 auto 0 auto",
  },
  button: {
    marginTop: "20px",
  },
  container: {
    padding: "1rem 2rem 1rem 2rem",
  },
  centered: {
    justifyContent: "center",
  },
};

export default fineCalculatorStyles;
